/*
  (c) 2025 Fluxonix Inc.
*/

import React, { useEffect } from 'react';
import { Grid, Typography, Card, CardContent, Box } from '@mui/material';
import AdminMetrics from './AdminMetrics';
import AdminAgents from './AdminAgents';
import RequireRole from '../components/RequireRole';

export default function AdminConsole() {
  useEffect(() => {
    console.log('🧭 AdminConsole mounted');
  }, []);

  return (
    <RequireRole role="admin">
    <Box sx={{ py: 4 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Admin Console
      </Typography>

      <Grid container spacing={4}>
        {/* Metrics Panel */}
        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                📊 Platform Metrics
              </Typography>
              <AdminMetrics />
            </CardContent>
          </Card>
        </Grid>

        {/* Agents Panel */}
        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                ⚙️ Agent Configuration
              </Typography>
              <AdminAgents />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
    </RequireRole>
  );
}
